import React from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { base16AteliersulphurpoolLight } from 'react-syntax-highlighter/dist/styles/prism';

const CodeBlock = ({ language, value }) => {
  return (
    <SyntaxHighlighter language={language} style={base16AteliersulphurpoolLight}>
      {value}
    </SyntaxHighlighter>
  );
}

export default CodeBlock;



// WEBPACK FOOTER //
// /Users/dnlytras/.npm/_npx/11463/lib/node_modules/landr/theme/src/components/CodeBlock.js